export default "__VITE_ASSET__Dq70p8uQ__";